import React, {Component} from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import classNames from 'classnames';

import { PageWrapper, Loader, Alert } from '../../components';
import Actions, { thunks } from '../../redux/modules/appUsers';
import Data from './components/Data';
import Cart from './components/Cart';

class UserDetails extends Component {
    state = {
        activeTab: 'data'
    }

    componentDidMount() {
        const { dispatch, match: { params: { id }} } = this.props;
        dispatch(thunks.getUserDetails(id));
        dispatch(thunks.getCart(id));
    }

    setTab = activeTab => {
        this.setState({ activeTab });
    }

    render() {
        const { 
            data,
            loading,
            error,
            updateProperty,
            cart,
            loadingCart,
        } = this.props;
        const { activeTab } = this.state;
        return (
            <PageWrapper title="User Details">
                <Loader show={loading}/>
                <Alert
                    show={!!error}
                    onHide={() => updateProperty('error', '')}
                    title="User Details"
                    message={error}
                />
                <div className="row mt-3">
                    <div className="col-lg-12">
                        <div className="card">
                            <ul className="nav nav-tabs">
                                <li className="nav-item" onClick={() => this.setTab('data')}>
                                    <a className={classNames('nav-link', { active: activeTab === 'data' })}>Details</a>
                                </li>
                                <li className="nav-item" onClick={() => this.setTab('cart')}>
                                    <a className={classNames('nav-link', { active: activeTab === 'cart' })}>Cart</a>
                                </li>
                            </ul>
                            <div className="card-body">
                                {activeTab === 'data' ? <Data data={data}/> : <Cart data={cart} dispatch={this.props.dispatch} loading={loadingCart} />}
                            </div>
                        </div>
                    </div>
                </div>
            </PageWrapper>
        )
    }
}

const mapStateToProps = ({
    appUsers: {
        loadingData: loading,
        error,
        data,
        cart,
        loadingCart,
    },
}) => ({
    loading,
    error,
    data,
    cart,
    loadingCart,
});

const mapDispatchToProps = dispatch => ({
    dispatch,
    updateProperty: bindActionCreators(Actions, dispatch).updateProperty,
});

export default connect(mapStateToProps, mapDispatchToProps)(UserDetails)